import { useCallback } from 'react';

import { env } from '@/env';

export interface File {
  readonly _id: string | null;
  readonly url?: string | null;
}

interface Props {
  type?: 'Group' | 'Service';
  machineName: string;
}

export function useGetFileUrl({ type = 'Group', machineName }: Props) {
  return useCallback(
    (file: File) => {
      const { _id: fileId, url } = file;

      if (url) {
        return url;
      }

      if (!fileId) {
        return '';
      }

      return `${env.NEXT_PUBLIC_APP_URL}/${type.toLowerCase().slice(0, 1)}/${machineName}/${type === 'Group' ? 'docs' : 'resources'}/${fileId}`;
    },
    [machineName, type],
  );
}
